import {
    HIDE_MESSAGE,
    INIT_URL,
    ON_HIDE_LOADER,
    ON_SHOW_LOADER,
    SHOW_MESSAGE,
    SIGNIN_USER,
    SIGNIN_USER_SUCCESS,
    SIGNIN_USER_FAILED,
    SIGNOUT_USER,
    SIGNOUT_USER_SUCCESS,
    SIGNOUT_USER_FAILED,
    ADD_PATIENT,
    ADD_PATIENT_SUCCESS,
    GET_LIST_OF_COUNTRIES,
    GET_LIST_OF_COUNTRIES_SUCCESS,
    GET_LIST_OF_COUNTRIES_FAILED,
    RESET_AUTH_INFO
} from 'constants/ActionTypes';

export const add_patient_details = (payload) => {
    return {
        type: ADD_PATIENT,
        payload
    };
};
export const add_patient_details_success = (payload) => {
    return {
        type: ADD_PATIENT_SUCCESS,
        payload
    };
};
export const user_sign_in = (payload) => {
    return {
        type: SIGNIN_USER,
        payload
    };
};

export const user_sign_in_success = (authUser) => {
    return {
        type: SIGNIN_USER_SUCCESS,
        payload: authUser
    }
};

export const user_sign_in_failed = (error) => {
    return {
        type: SIGNIN_USER_FAILED,
        payload: error
    }
};


// pas payload to the function
export const user_sign_out = (payload) => {
    if(sessionStorage.getItem('patientFilters') || sessionStorage.getItem('email_id')) {
        sessionStorage.clear();
    }
    return {
        type: SIGNOUT_USER,
        payload
    };
};

export const user_sign_out_success = () => {
    return {
        type: SIGNOUT_USER_SUCCESS,
    }
};

export const user_sign_out_failed = () => {
    return {
        type: SIGNOUT_USER_FAILED,
    }
};



export const show_auth_message = (message) => {
    return {
        type: SHOW_MESSAGE,
        payload: message
    };
};

export const hide_auth_message = () => {
    return {
        type: HIDE_MESSAGE,
    };
};

export const setInitUrl = (url) => {
    return {
        type: INIT_URL,
        payload: url
    };
};

export const show_auth_loader = () => {
    return {
        type: ON_SHOW_LOADER,
    };
};

export const hide_auth_loader = () => {
    return {
        type: ON_HIDE_LOADER,
    };
};

export const get_list_of_countries = () => {
    return {
        type: GET_LIST_OF_COUNTRIES,
    };
};

export const get_list_of_countries_success = (payload) => {
    return {
        type: GET_LIST_OF_COUNTRIES_SUCCESS,
        payload,
    };
};

export const get_list_of_countries_failed = () => {
    return {
        type: GET_LIST_OF_COUNTRIES_FAILED,
    };
};

export const reset_auth_info = () => ({
    type: RESET_AUTH_INFO
})